import React, { useEffect, useState } from "react";
import "../CSS/LeaderShip.css";

import leader1 from "../assets/img1.png";
import leader2 from "../assets/img2.png";
import leader3 from "../assets/img3.png";
import leader4 from "../assets/img4.png";
import leader5 from "../assets/img5.png";
import leader6 from "../assets/img6.png";
import leader7 from "../assets/img7.png";
import leader8 from "../assets/img8.png";
import leader9 from "../assets/img9.png";

const TruncatedText = ({ text, maxLength = 300 }) => {
  const [expanded, setExpanded] = useState(false);

  if (text.length <= maxLength) return <p>{text}</p>;

  return (
    <p>
      {expanded ? text : text.substring(0, maxLength) + "... "}
      <span className="read-more" onClick={() => setExpanded(!expanded)}>
        {expanded ? "Read Less" : "Read More"}
      </span>
    </p>
  );
};

const leaders = [
  {
    id: 1,
    name: "Dr. Pawan Singh",
    role: "Chairman",
    description: `IRAS (r), Ex MD and CEO PFS, Possess 40 years of rich experience at senior and leadership level in infrastructure finance & management.  
    He has been member of Board of Director for 17 years in several large companies. Areas of expertise include infrastructure management & finance decision making in investments, both debt and equity. Risk management, project appraisals etc. Apart from above dealt in structuring innovative financial transactions such as hybrid debt, quasi equity, bridge financing, mezzanine financing etc. handled strategic debt restructuring. Turn around strategist, MBA, PhD, Member Board of Governors MDI for 5 years, visiting faculty to.`,
    image: leader1,
  },
  {
    id: 2,
    name: "Dhiraj Mathur",
    role: "Leader",
    description: `As an IAS officer, Dhiraj has held senior positions in the government and after taking voluntary retirement, the corporate world, working with and advising the leadership in leading global and Indian companies like PwC, E&Y, Aequs, OPM among others.  
    He is a trained and certified Mediator and Coach, a Senior Advisor and an Independent Director. He coaches and also advises senior management of companies on strategy, public policy, corporate governance and regulatory regimes in a wide range of sectors including “green growth”.`,
    image: leader2,
  },
  {
    id: 3,
    name: "Ashish Kumar",
    role: "Leader",
    description: `Ashish holds a professional degree of CA from the Institute of Chartered Accountants of India. Entrepreneur with 14 years of experience in Finance and Taxation, FinTech, IoT, ecommerce, and digital media, businesses in India and globally.  
    Financial partner to founders and CEOs, with an emphasis on strategic planning, investor relations, corporate development, business development, human resources, IT, business operations and business analytics.`,
    image: leader3,
  },
  {
    id: 4,
    name: "Vikas",
    role: "Leader",
    description: `Vikas has an experience of 20 years plus spanning various business functions ranging from operations, sales, marketing, financial and insurance services, NBFC, HR etc. across industries and companies including Bose Corporation (India & Dubai), Fino Paytech Limited and Intrepid NBFC- MFI.  
    He has extensive experience in Strategic Business Management, HR, Process transitioning, Leadership development, training and operations.`,
    image: leader4,
  },
  {
    id: 5,
    name: "S. Siva Kumar",
    role: "Leader",
    description: `Experienced banking professional having over 34 years of total work experience in Infrastructure projects viz. Generation and Transmission Power Projects (Thermal, Hydro, Solar, Wind and Bio-mass), Infrastructure Projects (Road & Transport Sector, Urban Waste Disposal), industrial projects with expertise in Project Finance involving Credit Appraisals, Risk Analyses & Mitigation, Working Capital Financing, Venture Capital Financing, Syndication, Restructuring, Asset Reconstruction and Recovery.`,
    image: leader5,
  },
  {
    id: 6,
    name: "Anand Bhagavatula",
    role: "Leader",
    description: `A Professional with over 40 years of experience in Strategic Planning, Marketing, Business Development, Channel & Distribution Management and Team Management with a proven track record of increasing revenues.  
    Specialising in areas of Compliance, Payment receivables, Project agreements, Ensuring SLA and reducing any penalties.  
    Rich experience in State Government, Central Ministries, PSU, and BFSI for the last 30 years.  
    Establishing corporate strategies and budgets for the achievement of top line & bottom-line targets.  
    Streamlining existing processes to enhance efficiencies while minimizing operational time/costs.  
    Conducting competitor analysis & competency mapping for keeping abreast of market trends and competitors move to achieve market share metrics.  
    Identifying and developing new streams for revenue growth and maintaining relationships with customers to achieve repeat/referral business.  
    Startup & Business Advisory Services Strategic Growth Advisory: Currently engaged with various mid-sized organisations helping them achieve their goals.`,
    image: leader6,
  },
];

const extraLeaders = [
  {
    id: 7,
    name: "T B Singh",
    role: "Advisor",
    description: `Associated as Advisor with commissioning and ramp up of 3MT Greenfield Integrated Steel Plant of NMDC at Nagarnar, Jagdalpur, Chhattisgarh from May 2022 to May 2025.  
    Over 38 Years (March 1983-March 2021) of experience in SAIL in different capacities for Plant operation & Project Management at multiple units.  
    Project Management of Large Scale Capital Projects, Production Operation(Raw Material, Production Planning & execution , Logistics).  
    Liaison and Coordination with Ministries like Power, Environment, Coal ,Steel, Railway, Highway & Transport etc, and CPSUs & State PSUs.  
    Worked as Executive Director (Projects) & Executive Director (Works) at Durgapur & Bhilai Steel Plant of Steel Authority of India Ltd (SAIL).`,
    image: leader7,
  },
  {
    id: 8,
    name: "Nishant Bharadwaj",
    role: "Director, Ember",
    description: `Based in Seoul, South Korea. Nishant Bharadwaj is a clean energy and sustainable investment professional with over a decade of international experience driving renewable energy and green growth initiatives.  
    Currently serving as Director at Ember, he leads strategic programs promoting low-carbon energy transitions globally.  
    Previously worked with the Global Green Growth Institute (GGGI) for six years in leadership roles including Managing Director, Green Investment Services, and Global Head of Energy.  
    Before joining GGGI, served as Energy Adviser at the UK Department for International Development (DFID), leading policy and investment strategies for clean energy partnerships in India.`,
    image: leader8,
  },
  {
    id: 9,
    name: "Utkarsh Singh",
    role: "Associate Manager – ESG & Sustainability",
    description: `Fitsol, Gurugram, Haryana | August 2024 – Present. Key Expertise: ESG Compliance | Sustainability Strategy | Project Management | Water & Waste Management.  
    Associate Consultant – ESG & Sustainability, EY, Mumbai, Maharashtra | August 2023 – July 2024. Key Expertise: ESG Benchmarking | Competitor Analysis | Data-Driven Sustainability Insights.  
    Research Intern – ESG & Climate Change, CII–ITC Centre of Excellence for Sustainable Development, New Delhi | April 2023 – June 2023.  
    ESG Intern – KPMG, Gurugram, Haryana | June 2022 – August 2022. Key Expertise: ESG Risk Assessment | Resource Utilization Analysis | Sustainability Reporting.`,
    image: leader9,
  },
];

const Leadership = () => {
  useEffect(() => {
    const cards = document.querySelectorAll(".leader-card, .extra-card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    cards.forEach((card) => observer.observe(card));
  }, []);

  return (
    <section className="leadership-section">
      <h2 className="leadership-title">Meet Our Leadership Team</h2>

      <div className="leadership-container">
        {leaders.map((leader, index) => (
          <div
            key={leader.id}
            className={`leader-card ${index % 2 === 1 ? "reverse" : ""}`}
          >
            <div className="leader-image">
              <img src={leader.image} alt={leader.name} />
            </div>
            <div className="leader-info">
              <h3>{leader.name}</h3>
              <h4>{leader.role}</h4>
              <TruncatedText text={leader.description} maxLength={300} />
            </div>
          </div>
        ))}
      </div>

      <h2 className="extra-title">Advisory Members</h2>
      <div className="extra-leaders">
        {extraLeaders.map((leader) => (
          <div className="extra-card" key={leader.id}>
            <img src={leader.image} alt={leader.name} />
            <h3>{leader.name}</h3>
            <h4>{leader.role}</h4>
            <TruncatedText text={leader.description} maxLength={300} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Leadership;
